/**
 * Generates a table of contents from headings inside [vdx-toc-article] and appends items to [vdx-toc-list].
 * Supports multiple [vdx-toc-article] elements (e.g. two rich texts); headings from all are combined in DOM order.
 */

const slugFromHeading = (heading) =>
    heading.textContent.trim().replace(/[^a-zA-Z0-9\s-]/g, '').replace(/\s+/g, '-').toLowerCase();

export const generateTOC = () => {
    if (window.vdxTOCInitialized) return;
    window.vdxTOCInitialized = true;

    const tocList = document.querySelector("[vdx-toc-list]");
    const tocArticles = document.querySelectorAll("[vdx-toc-article]");

    if (!tocList || !tocArticles.length) return;

    const usedIds = new Set();
    const ensureUniqueId = (base) => {
        let id = base;
        let n = 1;
        while (usedIds.has(id)) {
            id = `${base}-${++n}`;
        }
        usedIds.add(id);
        return id;
    };

    /** All headings from all articles in DOM order (filled while wrapping). */
    const allHeadings = [];

    tocArticles.forEach((tocArticle) => {
        const headings = tocArticle.querySelectorAll("h1, h2, h3, h4, h5, h6");
        headings.forEach((heading) => {
            const wrapperDiv = document.createElement("div");
            const baseSlug = slugFromHeading(heading);
            wrapperDiv.id = ensureUniqueId(baseSlug);

            heading.parentNode.insertBefore(wrapperDiv, heading);
            wrapperDiv.appendChild(heading);

            let nextSibling = wrapperDiv.nextElementSibling;
            while (nextSibling && !nextSibling.tagName.match(/^H[1-6]$/i)) {
                const sibling = nextSibling;
                nextSibling = nextSibling.nextElementSibling;
                wrapperDiv.appendChild(sibling);
            }

            allHeadings.push(heading);
        });
    });

    if (allHeadings.length === 0) return;

    ["h1", "h2", "h3", "h4", "h5", "h6"].forEach((tag) => {
        const tocHeading = tocList.querySelector(`[vdx-toc-${tag}]`);
        if (tocHeading) tocHeading.style.display = "none";
    });

    allHeadings.forEach((heading) => {
        const tagName = heading.tagName.toLowerCase();
        const tocHeading = tocList.querySelector(`[vdx-toc-${tagName}]`);
        if (tocHeading) {
            const listItem = document.createElement("li");
            if (tocHeading.className) listItem.className = tocHeading.className;

            const anchor = document.createElement("a");
            anchor.href = `#${heading.parentNode.id}`;
            anchor.textContent = heading.textContent;

            const tocAnchor = tocHeading.querySelector("a");
            if (tocAnchor && tocAnchor.className) anchor.className = tocAnchor.className;

            listItem.appendChild(anchor);
            tocList.appendChild(listItem);
        }
    });
};
